import ViewerPage from './ViewerPage';

export default ViewerPage;
